import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';
import thTH from './locales/th-TH';
import ruRU from './locales/ru-RU';
import deDE from './locales/de-DE';
import { setLang, getLang } from '@/utils/dataStorage';

const resources = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'th-TH': thTH,
  'ru-RU': ruRU,
  'de-DE': deDE
};

// 获取当前语言，如果没有则使用中文
const currentLanguage = getLang();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: currentLanguage,
    fallbackLng: 'zh-CN',
    interpolation: {
      escapeValue: false
    }
  });

// 监听语言变化
i18n.on('languageChanged', (lng) => {
  setLang(lng);
  // localStorage.setItem('i18nextLng', lng);
});

export default i18n;
